import Button from "./Button";

export type { IButtonProps } from "./Button";

export default Button;
